<kendo-dialog *ngIf="active" (close)="closeForm()" [width]="740" [height]="520">
    <kendo-dialog-titlebar>
        Manage Queue
    </kendo-dialog-titlebar>

    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-4">
                <span>Namespace:</span>
            </div>   
            <div class="col-sm-8">
                <span>{{connection?.Namespace}}</span>
            </div>           
        </div>
        <div class="row">
            <div class="col-sm-4">
                <span>Queue:</span>
            </div>   
            <div class="col-sm-8">
                <span>{{model?.Name}}</span>
            </div>           
        </div>
        <div class="row">
            <div class="col-sm-12">
                <kendo-panelbar
                (stateChange)="onPanelChange($event)"
                [height]="400">
                    <kendo-panelbar-item [title]="activeTitle" [id]="1">
                        <ng-template kendoPanelBarContent>
                            <app-messages
                            [connection]="connection"
                            [store]="model"
                            [scope]="1"
                            [open]="activeOpened">
                            </app-messages>                            
                        </ng-template>
                    </kendo-panelbar-item>
                    <kendo-panelbar-item [title]="deadLetterTitle" [id]="2">
                        <ng-template kendoPanelBarContent>
                            <app-messages
                            [connection]="connection"
                            [store]="model"
                            [scope]="3"
                            [open]="deadLetterOpened"
                            (delete)="onDelete($event)">
                            </app-messages> 
                        </ng-template>
                    </kendo-panelbar-item>                    
                </kendo-panelbar>               
            </div>
        </div>     
    </div>

    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">Cancel</button>
    </kendo-dialog-actions>
</kendo-dialog>
`

